const base = {
  main: 'https://cnodejs.org/api/v1',
  token: 'cc3f9f9e-07e1-4238-97eb-4b43ca2fc7a8',
};

export default base;
